import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {useInstanceDetailPage} from '../../../../api/hooks/useInstanceDetail.hook';
import {Instance} from '../../../../api/models/instance';
import {InstanceStatus} from '../../../../api/models/instance-status';
import {Variant} from '../../../../api/models/variant';
import {cancelFixPrice, removeCancelFixPriceStatus} from '../../../../redux/slices/resale-slice';
import {ButtonVariantsEnum} from '../../../../utils/_enums/button-variants.enum';
import {TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import {
    getLocaleEthPrice,
    getLocalePrice
} from '../../../../utils/_helper/locale-helper';
import { useAppSelector } from '../../../../utils/_hooks/hooks';
import {Button} from '../../button/button';
import {Typography} from '../../typography/typography';
import SalesBoxConnectWallet from '../connect-wallet/sales-box-connect-wallet';
import styles from './cancel-resale-box.module.scss';

export interface CancelResaleBoxProps {
    instance: Instance;
    variant?: Variant;
}

const CancelResaleBox = (props: CancelResaleBoxProps) => {
    const data = useInstanceDetailPage();
    const dispatch = useDispatch();
    const [cancelConfirm, setCancelConfirm] = useState<boolean>(false);
    const {
        instance,
        walletId,
        cancelFixPriceModel
    } = useAppSelector((state) => ({
        instance: state.productSlice.instance,
        walletId: state.blockchainSlice.walletId,
        cancelFixPriceModel: state.resaleSlice.cancelFixPriceModel
    }));

    useEffect(() => {
        if (cancelFixPriceModel.status && cancelFixPriceModel.status !== 200) {
            dispatch(removeCancelFixPriceStatus());
        }
    }, [cancelFixPriceModel.status]);

    const cancelResale = () => {
        if (instance) {
            dispatch(cancelFixPrice(instance.id));
        }
    };

    if (instance && data) {
        return (
            <div>
                {walletId ? (
                    <div>
                        {walletId === instance.ownerWallet ? (
                            <div>
                                {cancelConfirm ? (
                                    <div className={styles['confirm-cancel-sale']}>
                                        <Typography
                                            className={styles['sales-type']}
                                            element={'span'}
                                        >
                                            {data.confimCancelSale.content}
                                        </Typography>
                                        <div
                                            className={
                                                styles['cancel-sale-actions']
                                            }
                                        >
                                            <Button
                                                variant={
                                                    ButtonVariantsEnum.SECONDARY_OUTLINED
                                                }
                                                className={
                                                    styles['cancel-button']
                                                }
                                                disabled={
                                                    cancelFixPriceModel.pending
                                                }
                                                onClick={() =>
                                                    setCancelConfirm(false)
                                                }
                                            >
                                                {data.backButton.buttonText}
                                            </Button>
                                            <Button
                                                className={
                                                    styles['cancel-button']
                                                }
                                                disabled={instance?.status !== InstanceStatus.OPEN}
                                                pending={cancelFixPriceModel.pending}
                                                onClick={cancelResale}
                                            >
                                                {
                                                    data.cancelSaleButton
                                                        .buttonText
                                                }
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <Typography
                                            className={styles['sales-type']}
                                            element={'span'}
                                        >
                                            {instance.status === InstanceStatus.OPEN
                                                ? data?.cancelSaleDescription?.content
                                                : data?.cannotCancelSaleDescription?.content}
                                        </Typography>
                                        <div className={styles['fixed-price-sale']}>
                                            <div className={styles['fixed-price-left-wrapper']}>
                                                <Typography className={styles['on-sale-for']}>
                                                    {
                                                        data.onSaleForPrice
                                                            .content
                                                    }
                                                </Typography>
                                                <Typography
                                                    variant={
                                                        TypographyVariantsEnum.HEADING3_BOLD
                                                    }
                                                    element={'span'}
                                                    className={`${styles['main-price']} ${styles['price']}`}
                                                >
                                                    {getLocaleEthPrice(
                                                        props.instance.priceEth
                                                    ) + 'Ξ'}
                                                </Typography>
                                                <Typography
                                                    className={`${styles['secondary-resale-price']} ${styles['price']}`}
                                                    variant={TypographyVariantsEnum.HEADING5_LIGHT}
                                                    element={'span'}
                                                >
                                                    {`(${getLocalePrice(
                                                        props.instance.priceFiat
                                                    )}€)`}
                                                </Typography>
                                            </div>
                                            <div className={styles['fixed-price-right-wrapper']}>
                                                <Button
                                                    onClick={() => setCancelConfirm(true)}
                                                    disabled={instance?.status !== InstanceStatus.OPEN}
                                                    className={styles['fixed-price-buy']}
                                                >
                                                    {data.abortResaleHeadline.headlineContent}
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <Typography className={styles['connect-wallet-wrapper']}>
                                {data.correctAccountWrongWalletPrompt.content}
                            </Typography>
                        )}
                    </div>
                ) : (
                    <div className={styles['connect-wallet-wrapper']}>
                        <SalesBoxConnectWallet/>
                    </div>
                )}
            </div>
        );
    } else {
        return <div/>;
    }
};

export default CancelResaleBox;
